import type { ItemPrefix, ItemTypeAdditionalParameters } from 'bundles/author-course/constants/ItemTypes';

import _t from 'i18n!nls/author-course';

function getAssignmentTranslation(isGraded?: boolean, isTeamAssignment?: boolean): string {
  if (isGraded === undefined || isGraded) {
    return isTeamAssignment ? _t('Graded Team Assignment') : _t('Graded Assignment');
  } else {
    return isTeamAssignment ? _t('Practice Team Assignment') : _t('Practice Assignment');
  }
}

export function getItemTypePrefixTranslation(
  key: ItemPrefix,
  itemTypeAdditionalParameters?: ItemTypeAdditionalParameters
): string {
  const { isTeamAssignment, useShortFormName, isGraded } =
    (itemTypeAdditionalParameters as ItemTypeAdditionalParameters) || {};
  switch (key) {
    case 'Video':
      return _t('Video');
    case 'Notebook':
      return _t('Notebook');
    case 'Reading':
      return _t('Reading');
    case 'Discussion Prompt':
      return _t('Discussion Prompt');
    case 'Graded Discussion Prompt':
      return _t('Graded Discussion Prompt');
    case 'Quiz':
      return _t('Quiz');
    case 'Peer Review':
      return _t('Peer Review');
    case 'Programming Assignment':
      return _t('Programming Assignment');
    case 'Assignment':
      if (useShortFormName) {
        return _t('Assignment');
      }

      return getAssignmentTranslation(isGraded, isTeamAssignment) || _t('Assignment');
    case 'App Item':
      return _t('App Item');
    case 'Graded Assignment':
      return useShortFormName ? _t('Assignment') : _t('Graded Assignment');
    case 'Graded Team Assignment':
      return useShortFormName ? _t('Assignment') : _t('Graded Team Assignment');
    case 'Practice Assignment':
      return useShortFormName ? _t('Assignment') : _t('Practice Assignment');
    case 'Practice Team Assignment':
      return useShortFormName ? _t('Assignment') : _t('Practice Team Assignment');
    case 'Teammate Review':
      return _t('Teammate Review');
    case 'Ungraded Plugin':
      return _t('Ungraded Plugin');
    case 'Graded Plugin':
      return _t('Graded Plugin');
    case 'Workspace':
      return _t('Workspace');
    case 'Ungraded Lab':
      return _t('Ungraded Lab');
    case 'WISEflow Item':
      return _t('WISEflow Item');
    case 'Dialogue':
      return _t('Dialogue');
    case 'Coach Item':
      return _t('Dialogue');
    case 'Role Play':
      return _t('Role Play');
    case 'Placeholder':
      return _t('Deprecated Item');
    default:
      return '';
  }
}
